var _style, _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDbIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108 107",
    style: {
      enableBackground: "new 0 0 108 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.27;fill:#FFFFFF;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    className: "st0",
    cx: 54,
    cy: 53.5,
    rx: 54,
    ry: 53.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-users",
    className: "st1",
    d: "M34,50.6c3.2,0,5.7-2.6,5.7-5.7c0-3.2-2.6-5.7-5.7-5.7s-5.7,2.6-5.7,5.7c0,0,0,0,0,0 C28.3,48.1,30.8,50.6,34,50.6z M74,50.6c3.2,0,5.7-2.6,5.7-5.7s-2.6-5.7-5.7-5.7c-3.2,0-5.7,2.6-5.7,5.7l0,0 C68.3,48.1,70.8,50.6,74,50.6L74,50.6z M76.9,53.5h-5.7c-1.5,0-3,0.6-4,1.7c3.7,2,6.2,5.6,6.7,9.8h5.9c1.6,0,2.9-1.3,2.9-2.9 c0,0,0,0,0,0v-2.9C82.6,56.1,80,53.5,76.9,53.5L76.9,53.5z M54,53.5c5.5,0,10-4.5,10-10s-4.5-10-10-10s-10,4.5-10,10 C44,49,48.5,53.5,54,53.5C54,53.5,54,53.5,54,53.5L54,53.5z M60.9,56.4h-0.7c-3.9,1.9-8.4,1.9-12.2,0h-0.7 c-5.7,0-10.3,4.6-10.3,10.3v2.6c0,2.4,1.9,4.3,4.3,4.3h25.7c2.4,0,4.3-1.9,4.3-4.3v-2.6C71.1,61,66.5,56.4,60.9,56.4L60.9,56.4z  M40.9,55.2c-1.1-1.1-2.5-1.7-4-1.7h-5.7c-3.2,0-5.7,2.6-5.7,5.7v2.9c0,1.6,1.3,2.9,2.9,2.9c0,0,0,0,0,0h5.9 C34.7,60.8,37.2,57.2,40.9,55.2L40.9,55.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbIcon1);
export default __webpack_public_path__ + "static/media/db-icon-1.b35002ea63374d12cf00580c91864c2e.svg";
export { ForwardRef as ReactComponent };